import moment from 'moment'
import socketio from 'socket.io-client'
import config from '../utils/apiUtils'

// Instance is mutable, cannot set in the state
let io = socketio()

export const state = {
  messages: [],
  notifications: 0
}
export const getters = {
  getSocket: () => io
}

export const mutations = {
  setMessages(currentState, messages) {
    currentState.chat.messages = messages
  },
  addMessages(currentState, messages) {
    currentState.chat.messages = [...currentState.chat.messages, messages]
  },
  addNotification(currentState) {
    currentState.chat.notifications = 1
  },
  clearNotification(currentState) {
    currentState.chat.notifications = 0
  }
}

export const actions = {
  joinAndListen({rootState, commit, dispatch}, serial) {
    if (!io.id || io.io.uri !== config(rootState.context.currentContext).chatService) {
      if (io.connected) {
        io.disconnect()
      }
      io = socketio.connect(config(rootState.context.currentContext).chatService, {
        path: '/chat/v2/socket.io/',
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: Infinity, // Par défaut illimité
        reconnectionDelay: 1000, // délai entre tentatives
        reconnectionDelayMax: 5000
      })

      // Nettoyer les anciens listeners pour éviter les doublons
      io.off('message_received')
      io.off('message_edited')
      io.off('message_deleted')

      io.on('message_received', message => {
        if (message.source === 'crm') {
          commit('addNotification')
        }
        dispatch('addMessages', message)
      })

      io.on('message_edited', editedMessage => {
        const existingIndex = rootState.chat.messages.findIndex(m => m.id === editedMessage.id)
        if (existingIndex !== -1) {
          const parsedMessage = {
            ...editedMessage,
            date: moment(editedMessage.date).format('YYYY-MM-DD HH:mm:ss'),
            seen_at: editedMessage.seen_at !== null ? moment(editedMessage.seen_at).format('YYYY-MM-DD HH:mm:ss') : null
          }
          
          const updatedMessages = [...rootState.chat.messages]
          updatedMessages[existingIndex] = parsedMessage
          commit('setMessages', updatedMessages)
          
          console.info('[ChatStore] Message mis à jour:', editedMessage.id)
        } else {
          console.warn('[ChatStore] Message à éditer non trouvé:', editedMessage.id)
        }
      })

      io.on('message_deleted', deletedMessage => {
        const updatedMessages = rootState.chat.messages.filter(m => m.id !== deletedMessage.id)
        if (updatedMessages.length !== rootState.chat.messages.length) {
          commit('setMessages', updatedMessages)
          console.info('[ChatStore] Message supprimé:', deletedMessage.id)
        } else {
          console.warn('[ChatStore] Message à supprimer non trouvé:', deletedMessage.id)
        }
      })

      io.emit('join_room', serial, () => {
        commit('setMessages', [])
        dispatch('loadMessages')
      })
    }
  },
  loadMessages({commit, rootState}) {
    io.emit('get_messages', {serial: rootState.authentication.client.serial}, (error, messages = []) => {
      if (error) {
        console.error(error)
      } else {
        commit(
          'setMessages',
          messages.filter(message => !(message.text && message.text.substring(0, 1) === '/'))
        )
      }
    })
  },
  setRead({rootState, commit}, messageId) {
    io.emit('add_seen', {
      serial: rootState.authentication.client.serial,
      seen_at: moment().format('YYYY-MM-DD HH:mm:ss'),
      seen_by: `${rootState.authentication.userProfile.firstName} ${rootState.authentication.userProfile.lastName}`,
      id: messageId
    })
    commit('clearNotification')
  },
  addMessages({commit, dispatch}, messages) {
    if (!(messages.text.substring(0, 1) === '/')) {
      commit('addMessages', messages)
      dispatch('loadMessages')
    }
  },
  sendMessage({rootState}, payload) {
    return new Promise((resolve, reject) => {
      io.emit('send_message', payload, error => {
        if (error) {
          reject(error)
        } else {
          resolve(payload)
        }
      })
    })
  }
}
export default {
  state,
  actions,
  mutations,
  getters
}
